<!--
통관정보 무시(검사안함) 취소
------------------------------------
-->
<template>
    <!-- 폼 화면 -->

    <div class="confirm-overlay" ref="confirm-overlay" v-show="display">
        <div class="confirm-dialog p-1rem">

            <div class="mt-1rem">
                <div class="font-bold">
                    [통관정보 검사안함 설정] 을 취소합니다.

                </div>

                <div class="mt-0d5rem">
                    통관정보 검사기능이 다시 설정됩니다.
                </div>

            </div>


            <div class="uk-text-right mt-1rem">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default"

                    @click="hideForm"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>


                <button
                    type="button"
                    class="uk-button uk-button-primary"

                    @click="submit"
                >
                    <i class="material-icons">refresh</i>
                    통관정보 검사설정 완료
                </button>
            </div>

        </div>
    </div>

</template>

<script>

export default {
    mixins: [
    ],
    props: {
        // csrf-token
        csrfToken: String,

        // (object) 하우스정보
        house: {
            type: Object,
            default: null,
        },

        // [TASK-153] 완료 후 페이지 새로고침 여부 (상세 해지 버튼 경유 시 true)
        refreshWhenDone: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            // (bool) 폼 display 여부
            display: false,

        };
    },
    mounted: function () {
        //console.log('mounted in component');
    },
    computed: {
    },
    methods: {
        /**
         * 입력폼 display
         */
        displayForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            document.body.appendChild(this.$refs['confirm-overlay']);
            this.display = true;
        },

        /**
         * 입력폼 hide
         */
        hideForm() {
            // 컨펌 엘리먼트 body 밑으로 이동
            this.display = false;
        },

        /**
         * 폼 띄우기
         */
        form() {

            //console.log(response);
            // 폼띄우기
            this.displayForm();
        },

        /**
         * 서브밋 전 검증
         * @return Promise
         */
        submitValidation() {
            return new Promise((resolve, reject) => {

                resolve();
            });


        },

        /**
         * submit
         */
        submit() {
            // 입력값 검증처리
            this.submitValidation().then(() => {
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/houses/' + this.house.id + '/unignore-customs-validation',
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            }).then((response) => {
                this.display = false;
                UIkit.modal.alert(response.msg).then(() => {
                    // [TASK-153] 상세 해지 버튼 경유 시 새로고침
                    if (this.refreshWhenDone) {
                        $.app.refresh();
                    }

                    // 완료이벤트
                    this.$emit('done');

                });
            }).catch((msg) => {
                alert(msg);
            });



        },
    },
}
</script>

<style lang="scss" scoped>


// 컨펌화면
.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .confirm-dialog {
        width: 50rem;
        max-width: 90%;

        background-color: #fff;

    }
}
</style>